import React from "react"
import { useTranslation } from 'react-i18next'
import { ReactComponent as RetakeIcon } from '../../icon/retake.svg'
import { PropsWithTheme } from "../../library/Theme"
import IconButton from "./IconButton"

interface RetakeButtonProps {
  onPress: () => void
}

export default function RetakeButton({ theme, onPress }: PropsWithTheme<RetakeButtonProps>) {
  const { t } = useTranslation()

  return (
    <IconButton theme={theme} text={t("capture.retake")} onPress={onPress}>
      <RetakeIcon style={theme.svgStyle} />
    </IconButton>
  )
}